export default __webpack_public_path__ + "static/media/wanna7.5db20cd1.png";